import { useContext } from 'react'
import { AccountCtx } from '@/contexts/accountCtx'

export function useAccount() {
  const ctx = useContext(AccountCtx)
  if (ctx === undefined) {
    throw new Error('useAccount must be used within an AccountProvider')
  }
  return ctx
}
